import { Card, Space, Typography } from 'antd';
import React from 'react';

const { Text, Title } = Typography;

/** Placeholder assessment workspace page showing the primary deep-dive view. */
export const WorkspacePage: React.FC = () => {
  return (
    <Space direction="vertical" size="large" className="page-stack">
      <Card>
        <Title level={4} style={{ margin: 0 }}>
          Assessment Workspace
        </Title>
        <Text type="secondary">
          Primary deep-dive view for assessment progress and generated artifacts.
        </Text>
      </Card>
    </Space>
  );
};

export default WorkspacePage;
